import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-board',
  template: `
  `
})
export class BoardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
